// @flow

import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { applyStylingHoc, type StyleOuterProps, type StyleProps } from '@fcse/tsbob/dist/lib/styling'
import { useIntl } from 'gatsby-plugin-intl'
import ScrollAnimation from 'react-animate-on-scroll'
// import classNames from 'classnames'
import ListItem from '../../basic/ListItem'
import messages from '../Products.lang'
import baseStyles from './../Products.scss'

const Img = <StaticImage src="../../../images/logo/quickstart.svg" alt="" objectFit="contain" className="image" />

const BgImg = (
  <StaticImage
    src="../../../images/products/quickstart/quickstart-box-bg.jpg"
    alt=""
    objectFit="cover"
    className="imageCover"
  />
)

type Props = {
  ...StyleProps
}

const TeaserQuickStart = ({ styles }: Props) => {
  const { formatMessage } = useIntl()

  return (
    <ScrollAnimation className={styles.animationContainer} animateIn="fadeInUp" animateOnce>
      <ListItem
        img={Img}
        styles={styles.item}
        title={formatMessage(messages.titleQuickstart)}
        btnLink="/products/quickstart/"
        btn={formatMessage(messages.aboutQuickstart)}
        info={<p>{formatMessage(messages.copyQuickstart)}</p>}
        bgImg={BgImg}
      />
    </ScrollAnimation>
  )
}

export default applyStylingHoc(baseStyles)<$Diff<Props, StyleProps> & StyleOuterProps, Function>(TeaserQuickStart)
